import * as React from "react";
import Spinner from "components/common/Spinner";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheckContext from "./LicenseCheckContext";
const useLicenseCheckForSubjects = () => {
  const { data: isValidSecurityLicense, isInitialLoading: isLoadingSecurityLicense } = useLicenseValidityForSubject(
    LICENSE_SUBJECTS.security
  );
  const { data: isValidIlluminateLicense, isInitialLoading: isLoadingIlluminateLicense } = useLicenseValidityForSubject(
    LICENSE_SUBJECTS.illuminate
  );
  const { data: isValidEnterpriseLicense, isInitialLoading: isLoadingEnterpriseLicense } = useLicenseValidityForSubject(
    LICENSE_SUBJECTS.enterprise
  );
  return {
    subjects: {
      security: { isValid: isValidSecurityLicense.valid },
      illuminate: { isValid: isValidIlluminateLicense.valid },
      enterprise: { isValid: isValidEnterpriseLicense.valid }
    },
    isLoading: isLoadingSecurityLicense || isLoadingIlluminateLicense || isLoadingEnterpriseLicense
  };
};
const LicenseCheckProvider = ({ children }) => {
  const { subjects, isLoading } = useLicenseCheckForSubjects();
  return /* @__PURE__ */ React.createElement(LicenseCheckContext.Provider, { value: subjects }, isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : children);
};
export default LicenseCheckProvider;
